import React from 'react';
import {
	AutocompleteInput,
	BooleanInput,
	BooleanField,
	Create,
	CloneButton,
	Datagrid,
	DateField,
	DateInput,
	Edit,
	EditButton,
	List,
	ReferenceInput,
	ReferenceField,
	SimpleForm,
	TextInput,
	TextField,
	SaveButton,
	useRecordContext,
	usePermissions,
	TopToolbar,
	SortButton,
	CreateButton,
	DatagridBody,
	RecordContextProvider,
} from 'react-admin';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
	CardActions, Grid, Typography, useMediaQuery,
} from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Toolbar } from 'ra-ui-materialui';
import {
	withMasterPermissions,
	WithMasterPermissions,
} from '../DataProviderExtension/authExtension';


const validatePromotion = (values) => {
	const {
		startDate, startShowDate, finishDate, offer, business,
	} = values;

	const errors = {};


	if (!startDate) {
		errors.startDate = 'Укажите дату начала акции';
	}

	if (!startShowDate) {
		errors.startShowDate = 'Укажите дату начала показа акции';
	}

	if (!finishDate) {
		errors.finishDate = 'Укажите дату окончания акции';
	}

	if (!offer?.short || !offer.short.trim()) {
		errors.offer = {};
		errors.offer.short = 'Заполните краткое описание';
	}

	if (!offer?.full || !offer.full.trim()) {
		if (!errors.offer) {
			errors.offer = {};
		}
		errors.offer.full = 'Заполните полное описание';
	}

	if (!business?.id) {
		errors.business = {};
		errors.business.id = 'Укажите партнера';
	}


	if (startDate && startShowDate && (new Date(startDate) < new Date(startShowDate))) {
		errors.startShowDate = 'Дата начала показа акции не должна быть позднее даты начала акции';
	}

	if (startDate && finishDate && new Date(finishDate) < new Date(startDate)) {
		const finishDateLessThanStartDateErrorMessage = 'Дата начала акции не должна быть позднее даты окончания акции';
		errors.finishDate = finishDateLessThanStartDateErrorMessage;
		errors.startDate = finishDateLessThanStartDateErrorMessage;
	}

	if (finishDate && (new Date(finishDate) < new Date())) {
		errors.finishDate = 'Дата окончания акции не должна быть раньше текущей даты';
	}

	return errors;
};

const parseFinishDate = (value) => {
	if (!value) return value;
	const lateValue = new Date(value);
	lateValue.setHours(23, 59, 59, 999);
	return lateValue;
};

const FormToolBar = () => {
	const { isLoading: isPermissionsLoading, permissions } = usePermissions();
	if (isPermissionsLoading) {
		return null;
	}
	return withMasterPermissions(
		permissions,
		<Toolbar />,
		<Toolbar><SaveButton /></Toolbar>,
	);
};

export const PromotionForm = (props) => {
	return (
		<SimpleForm {...props} validate={validatePromotion}>
			<DateInput label="Дата начала" source="startDate" />
			<DateInput label="Дата начала показа" source="startShowDate" />
			<DateInput label="Дата окончания" source="finishDate" parse={parseFinishDate} />
			<TextInput label="Краткое описание" source="offer.short" fullWidth />
			<TextInput label="Полное описание" source="offer.full" fullWidth multiline />
			<WithMasterPermissions>
				<ReferenceInput
					source="business.id"
					reference="Business"
					sort={{ field: 'title.short', order: 'ASC' }}
					allowEmpty
				>
					<AutocompleteInput
						label="Партнер"
						optionText="title.short"
						emptyText="Не выбран"
						filterToQuery={(searchText) => ({ 'title.short': searchText })}
						fullWidth
					/>
				</ReferenceInput>
				<BooleanInput label="Приостановлена" source="suspended" />
			</WithMasterPermissions>
		</SimpleForm>
	);
};

export const EditPromotion = (props) => {
	return (
		<Edit {...props}>
			<PromotionForm
				{...props}
				toolbar={<FormToolBar />}
			/>
		</Edit>
	);
};

export const createPromotion = (props) => {
	return (
		<Create {...props}>
			<PromotionForm {...props} />
		</Create>
	);
};

export const ClonePromotionButton = () => {
	const record = useRecordContext();
	return (
		<CloneButton
			record={
				{
					...record, suspended: true, id: undefined,
				}
			}
		/>
	);
};

const PromotionListRow = ({
	record,
}) => (
	<RecordContextProvider value={record}>
		<Card sx={{ mb: '0.375rem' }}>
			<CardContent>
				<Grid container spacing={1}>
					<Grid item xs={6} sm={6}>
						<DateField label="Дата начала" source="startDate" />
					</Grid>
					<Grid item xs={6} sm={6}>
						<DateField label="Дата окончания" source="finishDate" />
					</Grid>
					<Grid item xs={12} sm={12}>
						<TextField label="Краткое описание" source="offer.short" />
					</Grid>
					<Grid item xs={6}>
						<ReferenceField label="Партнер" source="business.id" reference="Business">
							<TextField source="title.short" />
						</ReferenceField>
					</Grid>
					<Grid item xs={6}>
						<Typography variant="body2" component="span">Приостановлена</Typography>
						<BooleanField label="Приостановлена" source="suspended" />
					</Grid>
				</Grid>
			</CardContent>
			<WithMasterPermissions>
				<CardActions>
					<EditButton />
					<ClonePromotionButton />
				</CardActions>
			</WithMasterPermissions>
		</Card>
	</RecordContextProvider>
);
const PromotionListDataGridBody = (props) => <DatagridBody {...props} row={<PromotionListRow />} />;

const ListActions = ({ isSmall }) => {
	return (
		<TopToolbar>
			{isSmall ? <SortButton fields={['startDate', 'finishDate']} /> : null }
			<CreateButton />
		</TopToolbar>
	);
};

export const ListPromotions = (props) => {
	const isSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));
	const { isLoading: isPermissionsLoading, permissions } = usePermissions();
	if (isPermissionsLoading) {
		return null;
	}
	return (
		<List
			{...props}
			title="Акции"
			actions={<ListActions isSmall={isSmall} />}
		>
			{
				isSmall
					? (
						<Datagrid
							rowClick="edit"
							header={() => (null)}
							body={<PromotionListDataGridBody />}
						/>
					)
					: (
						<Datagrid
							rowClick="edit"
							bulkActionButtons={withMasterPermissions(permissions, undefined, false)}
						>
							<DateField label="Дата начала" source="startDate" />
							<DateField label="Дата окончания" source="finishDate" />
							<TextField label="Краткое описание" source="offer.short" />
							<ReferenceField label="Партнер" source="business.id" reference="Business">
								<TextField source="title.short" />
							</ReferenceField>
							<BooleanField label="Приостановлена" source="suspended" />
							<WithMasterPermissions>
								<EditButton />
								<ClonePromotionButton />
							</WithMasterPermissions>
						</Datagrid>
					)
			}
		</List>
	);
};
